// extracted by mini-css-extract-plugin
export default {"connectButtons__btnConnect":"DynamicCategoryTable_connectButtons__btnConnect__YlChB","bg-QuickbooksDesktop":"DynamicCategoryTable_bg-QuickbooksDesktop__RfzDU"};